(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gsw-product-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gsw-product-bundle')) {
    customElements.define('gsw-product-bundle', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.grid = this.querySelector('[data-grid]');
        this.status = this.querySelector('[data-status]');
        this.slide = this.querySelector('[data-slide]');
        this.handle = this.querySelector('[data-slide-handle]');
        this.cartLink = this.querySelector('[data-cart-link]');
        this.railCount = this.querySelector('[data-rail-count]');
        this.prev = this.querySelector('[data-rail-prev]');
        this.next = this.querySelector('[data-rail-next]');
        this.milestone = this.querySelector('[data-milestone]');
        this.celebrated = new Set();
        this.lastCount = 1;
        this.root = this.dataset.root.replace(/\/?$/, '/');
        try { this.currentVariants = JSON.parse(this.querySelector('[data-current-variants]').textContent); } catch (error) { this.currentVariants = []; }
        this.grid.addEventListener('change', event => this.change(event));
        this.prev.addEventListener('click', () => this.moveRail(-1));
        this.next.addEventListener('click', () => this.moveRail(1));
        this.grid.addEventListener('scroll', () => this.updateRail(), { passive: true });
        this.handle.addEventListener('pointerdown', event => this.startSlide(event));
        this.handle.addEventListener('keydown', event => { if ((event.key === 'Enter' || event.key === ' ') && !this.handle.disabled) { event.preventDefault(); this.finishSlide(true); } });
        window.addEventListener('resize', () => this.updateRail());
        document.addEventListener('click', event => { if (event.target.closest('#gswpSizes')) setTimeout(() => this.update(), 0); });
        document.addEventListener('change', event => { if (event.target.closest('#gswpForm')) setTimeout(() => this.update(), 0); });
        this.load();
      }
      currentVariant() {
        const field = document.getElementById('gswpVariantId');
        const id = field ? String(field.value) : '';
        return this.currentVariants.find(variant => String(variant.id) === id) || this.currentVariants[0];
      }
      async load() {
        try {
          const url = new URL(this.root + 'collections/' + this.dataset.source, location.origin);
          url.searchParams.set('sort_by', 'created-descending');
          url.searchParams.set('section_id', 'gsw-bundle-data');
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error();
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const cards = Array.from(doc.querySelectorAll('[data-gswb-product]')).filter(card => card.dataset.product !== this.dataset.currentProduct && card.dataset.family === this.dataset.family).slice(0, Number(this.dataset.limit));
          this.grid.replaceChildren(...cards.map(card => document.importNode(card, true)));
          this.querySelector('[data-rail-title]').textContent = this.dataset.relatedTemplate.replace('[count]', cards.length);
          this.status.textContent = cards.length ? '' : this.dataset.empty;
          requestAnimationFrame(() => this.updateRail());
          this.update();
        } catch (error) {
          this.status.textContent = this.dataset.error;
        } finally {
          this.grid.setAttribute('aria-busy', 'false');
        }
      }
      moveRail(direction) {
        const card = this.grid.querySelector('[data-gswb-product]');
        if (!card) return;
        this.grid.scrollBy({ left: direction * (card.getBoundingClientRect().width + 10), behavior: 'smooth' });
      }
      updateRail() {
        const cards = Array.from(this.grid.querySelectorAll('[data-gswb-product]'));
        if (!cards.length) { this.railCount.textContent = '0 / 0'; this.prev.disabled = true; this.next.disabled = true; return; }
        const left = this.grid.getBoundingClientRect().left;
        let current = 0;
        cards.forEach((card, index) => { if (Math.abs(card.getBoundingClientRect().left - left) < Math.abs(cards[current].getBoundingClientRect().left - left)) current = index; });
        this.railCount.textContent = (current + 1) + ' / ' + cards.length;
        this.prev.disabled = this.grid.scrollLeft < 4;
        this.next.disabled = this.grid.scrollLeft + this.grid.clientWidth >= this.grid.scrollWidth - 4;
      }
      startSlide(event) {
        if (this.busy || this.handle.disabled || event.button !== 0) return;
        event.preventDefault();
        this.dragId = event.pointerId;
        this.dragStart = event.clientX;
        this.slide.classList.add('is-dragging');
        this.handle.setPointerCapture(event.pointerId);
        this.handle.addEventListener('pointermove', this.boundSlideMove ||= event => this.moveSlide(event));
        this.handle.addEventListener('pointerup', this.boundSlideEnd ||= event => this.endSlide(event));
        this.handle.addEventListener('pointercancel', this.boundSlideEnd);
      }
      slideMax() { return Math.max(0, this.slide.clientWidth - this.handle.offsetWidth - 10); }
      moveSlide(event) {
        if (event.pointerId !== this.dragId) return;
        const distance = Math.max(0, Math.min(this.slideMax(), event.clientX - this.dragStart));
        this.slide.style.setProperty('--slide-x', distance + 'px');
        this.dragDistance = distance;
      }
      endSlide(event) {
        if (event.pointerId !== this.dragId) return;
        const complete = (this.dragDistance || 0) >= this.slideMax() * .76;
        this.handle.releasePointerCapture?.(event.pointerId);
        this.dragId = null;
        this.slide.classList.remove('is-dragging');
        this.finishSlide(complete);
      }
      finishSlide(complete) {
        if (complete && !this.handle.disabled) {
          this.slide.style.setProperty('--slide-x', this.slideMax() + 'px');
          this.slide.classList.add('is-complete');
          this.add();
        } else {
          this.resetSlide();
        }
      }
      resetSlide() {
        this.dragDistance = 0;
        this.slide.classList.remove('is-complete');
        this.slide.style.setProperty('--slide-x', '0px');
      }
      change(event) {
        if (this.busy) return;
        const card = event.target.closest('[data-gswb-product]');
        if (!card) return;
        const select = card.querySelector('[data-variant]');
        const checkbox = card.querySelector('[data-select]');
        if (event.target === select) {
          checkbox.disabled = !select.value;
          checkbox.checked = !!select.value;
          if (select.value) card.querySelector('[data-price]').textContent = select.selectedOptions[0].dataset.money;
        }
        this.status.textContent = '';
        this.cartLink.hidden = true;
        this.update();
      }
      selectedCards() {
        return Array.from(this.grid.querySelectorAll('[data-gswb-product]')).filter(card => card.querySelector('[data-select]').checked && card.querySelector('[data-variant]').value);
      }
      money(cents) {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: this.dataset.currency || 'INR', maximumFractionDigits: 0 }).format(cents / 100);
      }
      pricing() {
        const current = this.currentVariant();
        const cards = this.selectedCards();
        const prices = cards.map(card => Number(card.querySelector('[data-variant]').selectedOptions[0].dataset.price));
        if (current) prices.unshift(Number(current.price));
        const count = prices.length;
        const regular = prices.reduce((sum, price) => sum + price, 0);
        let total = regular;
        if (count === 2) total = Math.round(regular * .85);
        if (count >= 3) total = Math.round(regular * .8);
        if (count >= 5) total = Math.min(total, regular - Math.min(...prices));
        return { cards, count, regular, total, saving: regular - total };
      }
      update() {
        const price = this.pricing();
        const reward = this.querySelector('[data-reward]');
        let message = this.dataset.unlockTwo;
        if (price.count === 2) message = this.dataset.unlockedTwo + ' ' + this.dataset.unlockThree;
        if (price.count === 3) message = this.dataset.unlockedThree;
        if (price.count === 4) message = this.dataset.unlockedThree + ' ' + this.dataset.unlockFive;
        if (price.count >= 5) message = this.dataset.unlockedFive;
        reward.textContent = message;
        const milestoneCopy = { 2: this.dataset.unlockedTwo, 3: this.dataset.unlockedThree, 5: this.dataset.unlockedFive }[price.count];
        if (price.count > this.lastCount && milestoneCopy && !this.celebrated.has(price.count)) this.celebrateTier(price.count, milestoneCopy);
        this.lastCount = price.count;
        this.querySelector('[data-piece-count]').textContent = Math.min(price.count, 5) + ' / 5';
        this.querySelector('[data-progress]').style.width = Math.min(100, price.count * 20) + '%';
        this.querySelector('[data-regular]').textContent = this.money(price.regular);
        this.querySelector('[data-total]').textContent = this.money(price.total);
        const savingRow = this.querySelector('[data-saving-row]');
        savingRow.hidden = !price.saving;
        this.querySelector('[data-saving]').textContent = price.saving ? this.money(price.saving) : '';
        this.querySelectorAll('[data-tier]').forEach(tier => tier.classList.toggle('is-on', price.count >= Number(tier.dataset.tier)));
        const thumbs = this.querySelector('[data-thumbs]');
        thumbs.replaceChildren();
        this.grid.querySelectorAll('[data-gswb-product]').forEach(card => card.classList.toggle('is-selected', price.cards.includes(card)));
        price.cards.slice(0, 4).forEach(card => {
          const photo = card.querySelector('img');
          if (photo) { const thumb = photo.cloneNode(); thumb.alt = ''; thumb.removeAttribute('sizes'); thumb.removeAttribute('srcset'); thumbs.append(thumb); }
        });
        const disabled = this.busy || price.count < 2 || !this.currentVariant()?.available;
        this.handle.disabled = disabled;
        this.slide.setAttribute('aria-disabled', String(disabled));
        this.querySelector('[data-button-copy]').textContent = price.count < 2 ? this.dataset.selectMore : this.dataset.add;
      }
      celebrateTier(count, copy) {
        this.celebrated.add(count);
        clearTimeout(this.milestoneTimer);
        clearTimeout(this.progressTimer);
        this.milestone.classList.remove('is-showing');
        this.milestone.setAttribute('aria-hidden', 'false');
        this.querySelector('[data-milestone-copy]').textContent = copy;
        const progress = this.querySelector('.gswb__progress');
        progress.classList.remove('is-unlocked');
        requestAnimationFrame(() => requestAnimationFrame(() => {
          this.milestone.classList.add('is-showing');
          progress.classList.add('is-unlocked');
        }));
        this.progressTimer = setTimeout(() => progress.classList.remove('is-unlocked'), 760);
        this.milestoneTimer = setTimeout(() => {
          this.milestone.classList.remove('is-showing');
          this.milestone.setAttribute('aria-hidden', 'true');
        }, 2400);
      }
      async add() {
        if (this.busy) return;
        const current = this.currentVariant();
        const cards = this.selectedCards();
        if (!current || !current.available || !cards.length) return;
        const items = [{ id: Number(current.id), quantity: 1 }, ...cards.map(card => ({ id: Number(card.querySelector('[data-variant]').value), quantity: 1 }))];
        this.busy = true;
        this.grid.querySelectorAll('input,select').forEach(element => element.disabled = true);
        this.handle.disabled = true;
        this.slide.setAttribute('aria-disabled', 'true');
        this.querySelector('[data-button-copy]').textContent = this.dataset.adding;
        this.status.textContent = '';
        let sent = false;
        try {
          sent = true;
          const response = await fetch(this.root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
          const result = await response.json();
          if (!response.ok || result.status) {
            this.status.textContent = typeof result.description === 'string' ? result.description : this.dataset.uncertain;
            this.cartLink.hidden = false;
            this.recover();
            return;
          }
          this.classList.add('is-celebrating');
          this.querySelector('[data-button-copy]').textContent = this.dataset.added;
          this.status.textContent = this.dataset.added;
          setTimeout(() => location.assign(this.dataset.cart), 720);
        } catch (error) {
          this.status.textContent = sent ? this.dataset.uncertain : this.dataset.error;
          this.cartLink.hidden = false;
          this.recover();
        }
      }
      recover() {
        this.busy = false;
        this.resetSlide();
        this.grid.querySelectorAll('[data-variant]').forEach(element => element.disabled = false);
        this.grid.querySelectorAll('[data-gswb-product]').forEach(card => { card.querySelector('[data-select]').disabled = !card.querySelector('[data-variant]').value; });
        this.update();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
